import { CONNECTION } from "../../config/Connections";
import { CONFIG_ } from "../../config/Config";
import { successnotify, warningnotify } from "../../components/ToasNotif/Toast";
import { __openModal } from "../Modal";

var get = "/siswa-active";
var post = "/siswa-active";
export const actGetDataSiswaLogin = () => {
  return (dispatch) => {
    let config = CONFIG_({ url: get, method: "GET" });
    dispatch({ type: "LOADING_SISWA_ACTIVE" });
    CONNECTION(config)
      .then((response) => {
        const { status, data } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_SISWA_ACTIVE",
            message: "Success get data",
            data: data,
            code: status,
          });
        }
        return dispatch({ type: "ERROR_SISWA_ACTIVE", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_SISWA_ACTIVE",
          message: "Network error..",
        });
      });
  };
};

export const actPostDataSiswaLogin = (params) => {
  return (dispatch) => {
    let config = CONFIG_({ url: post, data: params, method: "POST" });
    dispatch({ type: "LOADING_SISWA_ACTIVE" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Siswa has been created");
          dispatch(__openModal({ modal: "MODAL_ADD_SISWA", open: false }));
          return dispatch(actGetDataSiswaLogin());
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_SISWA_ACTIVE", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_SISWA_ACTIVE",
          message: "Network error..",
        });
      });
  };
};

export const actUpdateDataSiswaLogin = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, data: params, method: "PUT" });
    dispatch({ type: "LOADING_SISWA_ACTIVE" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_SISWA_ACTIVE",
            message: "Success put data",
          });
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_SISWA_ACTIVE", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_SISWA_ACTIVE",
          message: "Network error..",
        });
      });
  };
};

export const actDetailDataSiswaLogin = (params, filter = "student") => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({
      url: post + "/" + id + "?filter=" + filter,
      method: "GET",
    });
    dispatch({ type: "LOADING_SISWA_ACTIVE" });
    CONNECTION(config)
      .then((response) => {
        const { status, data } = response;
        if (status === 200 || Object.keys(data).length > 0) {
          return dispatch({
            type: "SUCCESS_ACTIVE_DETAIL",
            message: "Success get data",
            id: id,
            data: data,
            code: status,
          });
        }
        return dispatch({ type: "ERROR_SISWA_ACTIVE", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_SISWA_ACTIVE",
          message: "Network error..",
        });
      });
  };
};

export const actDeleteDataSiswaLogin = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "DELETE" });
    dispatch({ type: "LOADING_SISWA_ACTIVE" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Login log has been deleted");
          return dispatch(actGetDataSiswaLogin());
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_SISWA_ACTIVE", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_SISWA_ACTIVE",
          message: "Network error..",
        });
      });
  };
};
